__turbopack_context__.v({
  "blockQuote": "BlockQuote-module__wGMQ2q__blockQuote",
  "cite": "BlockQuote-module__wGMQ2q__cite",
  "citeLink": "BlockQuote-module__wGMQ2q__citeLink",
  "root": "BlockQuote-module__wGMQ2q__root",
});
